var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("api-errors", { attrs: { errors: _vm.getErrors } }),
      _vm._v(" "),
      _vm.loading
        ? _c("loading")
        : _vm.ready
        ? _c("div", [
            _c("div", { staticClass: "row margin-bottom-15" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "filter-container pull-left" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-group-btn",
                          staticStyle: { width: "40%" },
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterColumn,
                                  expression: "filterColumn",
                                },
                              ],
                              staticClass: "form-control",
                              staticStyle: { "border-radius": "4px 0 0 4px" },
                              attrs: { "aria-label": "Filter field selector" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.filterColumn = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("Select field to filter"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.filterableFields, function (field) {
                                return _c(
                                  "option",
                                  { key: field, domProps: { value: field } },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.formatLabel(field)) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterValue,
                            expression: "filterValue",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "Enter filter value...",
                        },
                        domProps: { value: _vm.filterValue },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.handleEnterKey.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.filterValue = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-btn" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { disabled: _vm.isFilterButtonDisabled },
                            on: { click: _vm.applyFilter },
                          },
                          [
                            _vm._v(
                              "\n                                    Filter\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: {
                              disabled:
                                !_vm.filterColumnQuery && !_vm.filterValueQuery,
                            },
                            on: { click: _vm.clearFilter },
                          },
                          [
                            _vm._v(
                              "\n                                    Clear\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group pull-right" }, [
                  _c(
                    "button",
                    { staticClass: "btn btn-primary", attrs: { disabled: "" } },
                    [
                      _c("i", { staticClass: "glyphicon glyphicon-th-large" }),
                      _vm._v(" Card View\n                    "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-default",
                      attrs: { href: _vm.listViewUrl },
                    },
                    [
                      _c("i", { staticClass: "glyphicon glyphicon-th-list" }),
                      _vm._v(" List View\n                    "),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel-body" }, [
              _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: {
                    display: "flex",
                    "min-height": "calc(100vh - 100px)",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-3",
                      staticStyle: { padding: "15px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "panel panel-default",
                          staticStyle: { height: "100%" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "panel-heading" },
                            [
                              _vm.refinementField &&
                              _vm.refinementField.length > 0
                                ? [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.formatLabel(
                                            _vm.refinementField[0]
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                                No refinement field available\n                            "
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "panel-body" }, [
                            _vm.filteredRefinementValues.length > 0
                              ? _c(
                                  "ul",
                                  { staticClass: "list-group" },
                                  _vm._l(
                                    _vm.filteredRefinementValues,
                                    function (value) {
                                      return _c(
                                        "li",
                                        {
                                          key: value,
                                          staticClass:
                                            "list-group-item refinement-item",
                                          class: {
                                            active:
                                              _vm.selectedRefinement ===
                                              (typeof value === "object"
                                                ? Object.values(value)[0]
                                                : value),
                                          },
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              _vm.handleRefinementClick(
                                                typeof value === "object"
                                                  ? Object.values(value)[0]
                                                  : value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                typeof value === "object"
                                                  ? Object.values(value)[0]
                                                  : value
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c("p", [
                                  _vm._v("No refinement values available"),
                                ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-9",
                      staticStyle: { padding: "15px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row cards-grid" },
                        _vm._l(_vm.transformedCards, function (card) {
                          return _c(
                            "div",
                            { key: card.id, staticClass: "col-sm-6 col-md-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "panel panel-default inventory-card",
                                },
                                [
                                  card.id && card.id !== "Unknown ID"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "panel-heading id-header",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "id-link",
                                              attrs: {
                                                href: card.absolute_url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "truncate-text",
                                                  attrs: { title: card.id },
                                                },
                                                [_vm._v(_vm._s(card.id))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.name && card.name !== "Unnamed"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "panel-heading name-header",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "truncate-text",
                                              attrs: { title: card.name },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(card.name) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.description
                                    ? _c("div", { staticClass: "panel-body" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "description",
                                            class: {
                                              expanded: _vm.isExpanded(card.id),
                                            },
                                            attrs: {
                                              title: !_vm.isExpanded(card.id)
                                                ? card.description
                                                : "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleTruncation(
                                                  card.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(card.description) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasVisibleCustomFields(card.custom_fields)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "panel-body custom-fields",
                                        },
                                        [
                                          _c(
                                            "dl",
                                            [
                                              _vm._l(
                                                card.custom_fields,
                                                function (value, key) {
                                                  return [
                                                    _vm.isFieldVisible(
                                                      key,
                                                      value,
                                                      card
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            key: key,
                                                            staticClass:
                                                              "field-row",
                                                          },
                                                          [
                                                            _c("dt", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatLabel(
                                                                    key
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("dd", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "truncate-container",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "truncate-text",
                                                                      attrs: {
                                                                        title:
                                                                          value,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                            " +
                                                                          _vm._s(
                                                                            _vm.formatDateValue(
                                                                              key,
                                                                              value
                                                                            )
                                                                          ) +
                                                                          "\n                                                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "panel-footer" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "details-link",
                                        attrs: {
                                          href: card.absolute_url,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v("Details")]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("ve-pagination", {
                  attrs: {
                    layout: ["total", "prev", "pager", "next", "jumper"],
                    total: _vm.totalCount,
                    "page-index": _vm.pageIndex,
                    "page-size": _vm.pageSize,
                  },
                  on: { "on-page-number-change": _vm.pageNumberChange },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }